/*
 * Copyright (c) 2022. 42 bv (www.42.nl). All rights reserved.
 */
"use strict";

/**
 * @ngdoc function
 * @name diceApp.component:diceQuestionBulkChange
 */
angular.module("diceApp").component("diceQuestionBulkChange", {
  bindings: {
    type: "<",
    evaluations: "<",
    onChange: "&",
    onCancel: "&"
  },
  templateUrl: "es6/evaluations/bulk/question.bulk.change.html",
  controllerAs: "questionBulkChangeController",
  controller: function (Evaluation, language, message, translateFilter) {
    const questionBulkChangeController = this;

    questionBulkChangeController.$onInit = function () {
      questionBulkChangeController.templateIds = [];

      setActions();
      questionBulkChangeController.onLanguage = language.onChange(setActions);
    };

    function setActions() {
      questionBulkChangeController.actions = [
        {
          label: translateFilter("Page.EvaluationList.BulkChange.Action.Add"),
          description: translateFilter(
            "Page.EvaluationList.BulkChange.AddQuestions.Description"
          )
        },
        {
          label: translateFilter(
            "Page.EvaluationList.BulkChange.Action.Override"
          ),
          description: translateFilter(
            "Page.EvaluationList.BulkChange.OverrideQuestions.Description"
          ),
          deleteRemaining: true
        }
      ];
    }

    questionBulkChangeController.$onDestroy = function () {
      questionBulkChangeController.onLanguage();
    };

    questionBulkChangeController.save = function () {
      Evaluation.bulkQuestion({
        evaluationIds: _.map(questionBulkChangeController.evaluations, "id"),
        templateIds: questionBulkChangeController.templateIds,
        deleteRemaining: questionBulkChangeController.action.deleteRemaining
      }).$promise.then((result) => {
        message.addInfoLabel("Message.Save.Success");
        questionBulkChangeController.onChange({ result });
      });
    };

    questionBulkChangeController.add = function (templateId) {
      questionBulkChangeController.templateIds.push(templateId);
    };

    questionBulkChangeController.remove = function (templateId) {
      questionBulkChangeController.templateIds =
        questionBulkChangeController.templateIds.filter(
          (id) => id !== templateId
        );
    };
  }
});
